import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'suggest',
  pure: false,
})
export class SuggestPipe implements PipeTransform {
  transform(items: any[] | null, value: string, field?: string): any {
    if (!items || !value) {
      return items;
    }

    if (!items) {
      return null;
    }

    if (field) {
      return items.filter((item) =>
        item[field].toLowerCase().includes(value.toLowerCase())
      );
    } else {
      return items.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
    }
  }
}
